import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from './api.service';
import { CommentsDialogComponent } from 'app/queue-box/comments-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ReOpenService {

  constructor(
    private apiService: ApiService,
    private dialog: MatDialog
  ) {}

  reopen(docId: number, modelName: string, onSuccess?: () => void) {
    const postData = {
      doc_id: docId,
      model: modelName
    };
    this.apiService.checkNextDocument(postData).subscribe({
      next: (res: any) => {
        if (res.status === true) {
          this.openCommentsDialog(docId, modelName, onSuccess);
        } else {
          alert(res.message);
        }
      },
      error: () => {
        alert('Something went wrong!');
      }
    });
  }

  private openCommentsDialog(
    docId: number,  
    model: string,
    onSuccess?: () => void
  ) {
    const dialogRef = this.dialog.open(CommentsDialogComponent, {
      width: '400px',
      data: {
        title: 'Re Open Request',
        message: 'Add comments (optional):',
        isRequired: false,
        action: 'Save',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const postData = {
          doc_id: docId,
          model: model,
          comments: result.comments,
          type: 'reopen'
        };
        this.apiService.checkNextDocument(postData).subscribe({
          next: (res: any) => {
            alert(res.message);
            if (onSuccess) {
              onSuccess();
            }
          },
          error: () => {
            alert('Something went wrong!');
          }
        });
      }
    });
  }
}
